import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

export default function FAQ({ items, dark = false }) {
  return (
    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
      {items.map((item, i) => (
        <Reveal key={i} delay={i * 0.05}>
          <AccordionItem
            value={`faq-${i}`}
            className={dark ? "border-white/10" : "border-slate-200"}
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className={`text-left font-display text-lg sm:text-xl font-semibold uppercase tracking-wide hover:no-underline ${
                dark ? "text-white hover:text-frost" : "text-navy hover:text-ember"
              } transition-colors`}
            >
              <span className="flex items-baseline gap-4">
                <span className={`font-mono text-xs ${dark ? "text-frost" : "text-ember"}`}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                {item.q}
              </span>
            </AccordionTrigger>
            <AccordionContent
              data-testid={`faq-content-${i}`}
              className={`text-sm sm:text-base leading-relaxed pl-9 ${
                dark ? "text-slate-300" : "text-slate-600"
              }`}
            >
              {item.a}
            </AccordionContent>
          </AccordionItem>
        </Reveal>
      ))}
    </Accordion>
  );
}
